export class Kindle {
    static async getHighlights() {
        let kindleData = {
            name: "",
            urlId: "",
            highlights: [],
        };

        // get name of book
        let nameElement = document.querySelector("h3.kp-notebook-metadata");
        if (nameElement) {
            kindleData.name = nameElement.innerText.trim();
        }

        // get href from element then get the id from the url
        let urlElement = document.querySelector("a.kp-notebook-printable");
        if (urlElement) {
            let urlId = urlElement.href.split("/").pop();
            kindleData.urlId = urlId;
        }

        // get highlight text, note, and location value
        let highlightElements = Array.from(
            document.querySelectorAll(
                "#kp-notebook-annotations > div:not(#empty-annotations-pane)",
            ),
        );
        highlightElements.forEach((highlightElement) => {
            let highlightDiv = highlightElement.querySelector(
                "div.kp-notebook-highlight",
            );

            if (!highlightDiv) return;

            let highlightText = highlightDiv.innerText.trim();
            let noteElement = highlightElement.querySelector(
                "div.kp-notebook-note",
            );
            let noteText = "";
            if (noteElement) {
                let noteSpan = noteElement.querySelector("span#note");
                noteText = noteSpan ? noteSpan.innerText.trim() : "";
            }

            let locationElement = highlightElement.querySelector(
                "input#kp-annotation-location",
            );
            let locationValue = locationElement ? locationElement.value : "";

            let highlight = {
                text: highlightText,
                note: noteText,
                locationValue: locationValue,
            };

            kindleData.highlights.push(highlight);
        });

        return kindleData;
    }

    static async redirectAndLocateToKindle(kindleUrl) {
        window.open(kindleUrl, "_self");
    }

    static createKindleUrl(url) {
        // get id after asin= and before &
        let kindleUrlID = url.split("asin=").pop().split("&")[0];
        return `https://www.amazon.com/gp/search?ie=UTF8&tag=collabwriting-20&linkCode=ur2&linkId=7968c3197cdedbdcebf4cde90e7c9950&camp=1789&creative=9325&index=books&keywords=${kindleUrlID}`;
    }
}
